<template>
  <b-button v-if="visible" size="sm" variant="primary" :to="{ name: 'vehicle_status_history' }" aria-label="VSM History">
    <i class="fa fa-history"></i>
  </b-button>
</template>

<script>
import { mapState } from 'vuex'
import { hasVsmHistoryAccess } from '../utils/vsm_access'

export default {
  name: 'VsmHistoryLinkButton',
  computed: {
    ...mapState({ user: state => state.profile.user }),
    visible() { return hasVsmHistoryAccess(this.user) },
  },
}
</script>
